import useRequest from '@/websdk/utils/request';
export default (function () {
    const { exec, isRequestSuccessed } = useRequest({
    name: 'POST_FIRST_INSPECTION',
    url: `/api/inspection/first/main/`,
    method: 'POST',
  });
 

  return [exec, isRequestSuccessed];
});
